<template>
  <rounded-card height="65%">
    <div class="flex flex-col flex-1 items-center justify-between text-center">
      <h3 class="text-xl font-semibold leading-8" v-html="title"></h3>
      <img src="@/assets/MobileScan/store-applied.svg" :alt="title" />
      <c-button class="mb-20" @click="$emit('close')">
        <span>{{ btnText }}</span>
      </c-button>
    </div>
  </rounded-card>
</template>

<script>
import { mapGetters } from 'vuex';

import RoundedCard from '@/components/common/RoundedCard.vue';
import CButton from '@/components/common/CButton.vue';

export default {
  name: 'WelcomePrompt',
  components: {
    RoundedCard,
    CButton,
  },
  computed: {
    ...mapGetters('app', ['storeName', 'welcomeMessage']),
    ...mapGetters('user', ['isAuthenticated']),
    title() {
      return (
        this.welcomeMessage || this.$t('login.welcome_to_store', { storeName: this.storeName })
      );
    },
    btnText() {
      return this.isAuthenticated ? this.$t('login.continue') : this.$t('login.login_to_continue');
    },
  },
  watch: {
    prompt,
  },
};
</script>

<style scoped></style>
